import React from 'react';
import styled from 'styled-components';

import flexbox from 'styles/utils/flexbox';

const PackageCardSmallPlaceholder = () => (
  <Container>
    <PlaceholderImage />
    <PlaceholderContent />
    <PlaceholderContentSecondary>
      <LeftContainer />
      <BoardsContainer>
        <PlaceholderBoard />
        <PlaceholderBoard />
        <PlaceholderBoard isLast />
      </BoardsContainer>
    </PlaceholderContentSecondary>
  </Container>
);

export default PackageCardSmallPlaceholder;

// Styled Components
const separatorMargin = '8px';
const borderRadius = '5px';

const Container = styled.div`
  display: inline-block;
`;

const PlaceholderImage = styled.div`
  width: 300px;
  height: 208px;
  margin-bottom: ${separatorMargin};
  background-color: ${(props) => props.theme.colors.background.placeholder};
  border-radius: ${borderRadius};
  vertical-align: middle;

  animation: react-placeholder-pulse 1.5s infinite;
`;

const PlaceholderContent = styled.div`
  width: 300px;
  height: 93px;
  margin-bottom: ${separatorMargin};
  background-color: ${(props) => props.theme.colors.background.placeholder};
  border-radius: ${borderRadius};

  animation: react-placeholder-pulse 1.5s infinite;
`;

const PlaceholderContentSecondary = styled.div`
  ${flexbox({})}
  width: 300px;
`;

const LeftContainer = styled.div`
  width: 93px;
  height: 93px;
  margin-right: ${separatorMargin};
  background-color: ${(props) => props.theme.colors.background.placeholder};
  border-radius: ${borderRadius};

  animation: react-placeholder-pulse 1.5s infinite;
`;

const BoardsContainer = styled.div``;

const PlaceholderBoard = styled.div`
  width: 253px;
  height: 26px;
  margin-bottom: ${({ isLast }) => (isLast ? 0 : separatorMargin)};
  background-color: ${(props) => props.theme.colors.background.placeholder};
  border-radius: ${borderRadius};

  animation: react-placeholder-pulse 1.5s infinite;
`;
